export const DATABASE_API_URL = 'https://database-9u2b.onrender.com';
export const STOCK_SEARCH_API_URL = 'https://stock-search-bzzb.onrender.com';
export const BACKEND_API_URL = 'https://backend-231a.onrender.com';
export const LOGIN_API_URL = 'https://login-page-8fvl.onrender.com';
